import { FC } from "react";
import { Button } from "@earned/core";
import { HiOutlineLockClosed } from "react-icons/hi";
import { ExternalLinks, themeTextColors } from "@common/constants";
import { Typography } from "@earned/core";

interface MxZeroStateAgreementProps {
  onAccept: () => void;
}

const MxZeroStateAgreement: FC<MxZeroStateAgreementProps> = ({ onAccept }) => {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 p-10">
      <Typography variant="title-lg" color="primary">
        <div className="max-w-[500px] text-center">
          Connect your 401K and other financial accounts for a 360° view
        </div>
      </Typography>
      <div className="flex flex-row gap-2">
        <div className="flex-none">
          <HiOutlineLockClosed
            size={24}
            color={themeTextColors.primary}
            className="inline-block align-bottom"
          />
        </div>
        <div className="flex flex-col">
          <Typography variant="body" color="primary">
            Your information is protected with bank-level security:
          </Typography>
          <ul className="list-inside list-disc pl-2.5 text-body-xs">
            <li>
              <Typography variant="body" color="primary" component="span">
                We don&apos;t know or store your usernames and passwords.
              </Typography>
            </li>
            <li>
              <Typography variant="body" color="primary" component="span">
                Your data is passed through secure channels.
              </Typography>
            </li>
            <li>
              <Typography variant="body" color="primary" component="span">
                Your data is always encrypted.
              </Typography>
            </li>
          </ul>
        </div>
      </div>
      <div className="flex max-w-[450px]">
        <Typography variant="body-xs" color="secondary">
          By clicking continue you agree to provide this app with access to your
          account balance and transaction details, until you choose to
          disconnect. See{" "}
          <a
            href={ExternalLinks.PrivacyPolicy}
            rel="noreferrer"
            target="_blank"
            className="text-link underline"
          >
            Privacy Policy
          </a>
          .
        </Typography>
      </div>
      <Button variant="primary" onClick={onAccept}>
        Continue
      </Button>
    </div>
  );
};

export default MxZeroStateAgreement;
